import { useEffect, useState } from 'react'

import SwaggerUI from 'swagger-ui-react'

import { getRequestInterceptor, useSwaggerScroll } from './helper'
import { ExplorePlugin } from '~/portal/components/ApiViewer/ExplorePlugin'
import { LastModifiedDatePlugin } from '~/portal/components/LastModifiedDate'
import { usePersonalizedAuth } from '~/portal/hooks/usePersonalizedAuth'
import { useUser } from '~/portal/hooks/useUser'
import { OpenAPI2Definition, OpenAPI3Definition } from '~/portal/types/api.definitions'
import { SHUBApiDetails } from '~/shared/types/api'
import { RoutingSettings } from '~/shared/types/portal'

interface SwaggerRendererProps {
  definition: OpenAPI2Definition | OpenAPI3Definition,
  containerRef: HTMLDivElement | undefined,
  hash: string,
  exploreUrl?: string,
  SHUBApiDetails: SHUBApiDetails
  oasVersion: string
  lastModifiedDate?: string
  routingSettings?: RoutingSettings
}

export default function SwaggerRenderer({ definition, containerRef, hash, exploreUrl, SHUBApiDetails, oasVersion, lastModifiedDate, routingSettings }: SwaggerRendererProps) {

  const [oauth2RedirectUrl, setOauth2RedirectUrl] = useState<string>('')

  useEffect(() => {
    setOauth2RedirectUrl(`${window.location.protocol}//${window.location.host}/oauth2_redirect`)
  }, [])

  useSwaggerScroll(containerRef, hash)

  const { user } = useUser()
  const personalizedAuthActive = usePersonalizedAuth()

  const { version = '', orgName: swaggerhubOrgName = '', name: swaggerhubApiName = '' } = SHUBApiDetails

  const plugins = [
    exploreUrl ? ExplorePlugin({ exploreUrl, version, swaggerhubOrgName, swaggerhubApiName, oasVersion }) : null,
    LastModifiedDatePlugin({ lastModifiedDate })
  ].filter(Boolean)

  return (
    oauth2RedirectUrl ? <SwaggerUI 
      key={`swaggerUI-${swaggerhubOrgName}-${swaggerhubApiName}-${version}`}
      spec={definition}
      requestSnippetsEnabled={true}
      plugins={plugins}
      requestInterceptor={getRequestInterceptor(user, personalizedAuthActive, routingSettings)}
      showMutatedRequest={false}
      oauth2RedirectUrl={oauth2RedirectUrl}
    /> : null
  )
}